import Axios, { AxiosInstance } from 'axios';
const isLocalhost =
  typeof window !== 'undefined' && window.location.hostname === 'localhost';
// Only include token if running on localhost

// const token = null;
// const token = isLocalhost
//   ? '327975|MzRQpaJkfK5BPnBZAohWhZr3OVAVTSVoYaAfmvQo'
//   : null;

const axios: AxiosInstance = Axios.create({
  baseURL: process.env.NEXT_PUBLIC_BACKEND_URL as string,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
  withXSRFToken: true,
});

axios.interceptors.request.use(
  (config) => {
    if (typeof window !== 'undefined') {
      const isLocalhost = window.location.hostname === 'localhost';

      // Priority:
      // 1. token from localStorage
      // 2. fallback localhost token
      const token = localStorage.getItem('token') || '';

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axios;
